import './App.css';
import Card from "./Card"
import socialAppsData from "./appData/socialAppsData"
import ridehailingAndFoodAppsData from "./appData/ridehailingAndFoodAppsData"
import React, { useEffect } from 'react';
import Footer from './footer'
import googleAppsData from './appData/googleAppsData';
import indiaAppsdata from './appData/indiaAppsdata';
import entertainmentAppsdata from './appData/entertainmentAppsData';
import openSourceAppsdata from './appData/openSourceAppsdata';
import datingAppsdata from './appData/datingAppsData';
import microsoftAppsData from './appData/microsoftAppsData';
import miscAppsData from './appData/miscAppsData';
import { Analytics } from '@vercel/analytics/react';


function App() {

  useEffect(() => {

    document.body.style.backgroundImage = 'linear-gradient(to right,#ddd6f3, #faaca8)';
    document.body.style.backgroundImage = 'linear-gradient(to right,#ddd6f3, #faaca8)';
  }, []);
 
  const socialCards = socialAppsData.map(item => {
    return (
        <Card
            key={item.id}
            item={item}
        />
    )
}) 
const ridehailingAndFoodCards = ridehailingAndFoodAppsData.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const googleAppsDataCards = googleAppsData.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const indiaAppsDataCards = indiaAppsdata.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const entertainmentAppsCards = entertainmentAppsdata.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const openSourceAppsCards = openSourceAppsdata.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const datingAppsCards = datingAppsdata.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const microsoftAppsCards = microsoftAppsData.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})
const miscAppsCards = miscAppsData.map(item => {
  return (
      <Card
          key={item.id}
          item={item}
      />
  )
})

  return (
    <div className="App">
      <header className="App-header">
      <p className="app-category">App Release Insights</p>
      <p className="app-para">Track app releases of popular apps on Google Play</p>
      </header>
      <div className="app-category">Social Apps</div>
      <div className="cards-list">
                {socialCards}
            </div>
            <div className="app-category">Ridehailing & Delivery Apps</div>
            <div className="cards-list">
                {ridehailingAndFoodCards}
            </div>
            <div className="app-category">Entertainment Apps</div>
            <div className="cards-list">
                {entertainmentAppsCards}
            </div>
            <div className="app-category">Google Apps</div>
            <div className="cards-list">
                {googleAppsDataCards}
            </div>
            <div className="app-category">Open Source Apps</div>
            <div className="cards-list">
                {openSourceAppsCards}
            </div>
            <div className="app-category">Dating Apps</div>
            <div className="cards-list">
                {datingAppsCards}
            </div>
            <div className="app-category">Indian Apps</div>
            <div className="cards-list">
                {indiaAppsDataCards}
            </div>
            <div className="app-category">Microsoft Apps</div>
            <div className="cards-list">
                {microsoftAppsCards}
            </div>
            <div className="app-category">Miscellaneous Apps</div>
            <div className="cards-list">
                {miscAppsCards}
            </div>
            <Footer/>
            <Analytics />
    </div>
  );
}



export default App;
